import React, { useContext, useState, useEffect } from 'react';
import { Input, Button, Step, ActionLink } from '../../atoms';
import { UserContext } from '../../../context';
import { AuthService } from '../../../services';

import { validateConfirmPassword } from '../../../utils/input.validator';
import { default as t } from '../../../utils/i18n';

import './choose-password.scss';

function ChoosePassword({ atStep, updateStep }) {
  const { user, setUser } = useContext(UserContext);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [disableButton, setDisableButton] = useState(true);
  const [confirmValidationError, setConfirmValidationError] = useState(null);
  const [passwordValidationError, setPasswordValidationError] = useState(null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  const handlePasswordChange = e => {
    const { name, value } = e.target;
    setPasswordValidationError(null);
    setConfirmValidationError(null);
    if (name === 'password') {
      setPassword(value);
      if(value && value === confirmPassword && /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(value)){
          setDisableButton(false);
      }
          else{
            setDisableButton(true);
        } 
    } 
  };

  const handlePasswordBlurChange = e =>{
    const { name, value } = e.target;
    if (name === 'password') {
      setPassword(value);
      if (value==="") {
        setPasswordValidationError(t('error.CL_USR_000'));
      } else if (value && value!="" && !/^(?=.*\d)(?=.*[-+_!@#$%^&*., ?])(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(value)) {
        setPasswordValidationError(t('error.CL_USR_003'));
      }    
    } 
  }
  const handleConfirmChange = e => {
    const { name, value } = e.target;
    setConfirmValidationError(null);
  if (name === 'confirmPassword') {
      setConfirmPassword(value);  
      if (password === value) {
        if(passwordValidationError === null){
          setDisableButton(false);
        }    
      } else {
        setConfirmValidationError(t('error.validation.passwordDoNotMatch'));
        setDisableButton(true);
      }
    }
  };



  const handleSubmit = async e => {
    e.preventDefault();

    
    try {
      const signUpUser = await AuthService.signUp(user.username.toLowerCase(), password);
      setUser(prevUserState => ({
        ...prevUserState,
        username: signUpUser?.data?.data?.username,
        userConfirmed: signUpUser?.data?.data?.userConfirmed,
        signup: {
          step: 3,
        },
        isVerifyOtp:true,
        timestamp:new Date().getTime()
      }));
      updateStep(3);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        setConfirmValidationError(t(`error.${dataCode}`));
        setDisableButton(true);
      }
    }
      // setUser(prevUserState => ({
      //   ...prevUserState,
      //   signup: {
      //     step: 3,
      //   },
      //   isVerifyOtp:true
      // }));

      // updateStep(3);
  };
  const backtoStep1 = e => {
    e.preventDefault();
    setUser(prevUserState => ({
      ...prevUserState,
      signup: {
        step: 1,
      },
    }));
    updateStep(1);
  }

  const handleOnSignInNow = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  const checkupperCase = e => {
    var pattern = new RegExp(
      "^(?=.*[A-Z]).+$"
    );
  return pattern.test(e);
  }
  const checkNumeric = e => {
    var pattern = new RegExp(
      "^(?=.*\\d).+$"
    );
  return pattern.test(e);
  }
  const checkSpecialChar = e => {
    var pattern = new RegExp(
      "^(?=.*[-+_!@#$%^&*., ?]).+$"
    );
  return pattern.test(e);
  }

  if (!isMounted) {
    return null;
  }

  return (
    <div className="signup-step2__card-container">
      <p className="signup-step2__heading">
        {t('signup.step2.heading')}{' '}
        <span className="signup-step2__heading-username">{user.name}</span>
      </p>
      <p className="signup-step2__heading-email">({user.username})</p>
      <p className="signup-step2__subheading">{t('signup.step2.subHeading')}</p>
      <div className="signup-step2__password-policy">
        <p className="signup-step2__password-policy-title">
          {t('signup.step2.passwordPolicyTitle')}:
        </p>
        <ul>
          <li>
          {!checkupperCase(password) && (<i className="fas fa-arrow-right"></i>)}
            {checkupperCase(password) && (<i className="fas fa-check check"></i>)}
            {t('signup.step2.passwordPolicy1')}</li>
          <li>
          {!checkNumeric(password) && (<i className="fas fa-arrow-right"></i>)}
            {checkNumeric(password) && (<i className="fas fa-check check"></i>)}
            {t('signup.step2.passwordPolicy2')}</li>
          <li>
          {!checkSpecialChar(password) && (<i className="fas fa-arrow-right"></i>)}
            {checkSpecialChar(password) && (<i className="fas fa-check check"></i>)}
            {t('signup.step2.passwordPolicy3')}</li>
        </ul>
      </div>

      <div className="signup-step2__input-form-group">
        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <Input
              labelValue={t('user.input.label.password')}
              name="password"
              fieldType="password"
              placeholder={t('user.input.placeholder.enterPassword')}
              handleChange={handlePasswordChange}
              value={password}
              onBlurChange={handlePasswordBlurChange}
              errorMessage={passwordValidationError}
            />

            <Input
              labelValue={confirmValidationError? t('user.input.placeholder.reEnterPassword') : t('user.input.label.confirmPassword')}
              name="confirmPassword"
              fieldType="password"
              placeholder={t('user.input.placeholder.reEnterPassword')}
              handleChange={handleConfirmChange}
              onBlurChange={handleConfirmChange}
              value={confirmPassword}
              errorMessage={confirmValidationError}
            />
          </div>
          <div className="btn-container">
            <Button
              type="submit"
              name="submit"
              label={t('signup.button.continue')}
              disabled={disableButton}
            />
          </div>
        </form>
      </div>
      {/* <div className="step-container">
        <Step atStep={atStep}></Step>
      </div> */}
      <div className="step1__footer">
          <ActionLink anchor={true} value={`<  ${t('forgot.common.backLink')}`}  handleClick={backtoStep1} />
        </div>
      {/* <div className="signup-step2__footer">
        {t('signup.step1.footer')}{' '}
        <ActionLink
          value={t('user.link.signInNow')}
          redirectTo="/signIn"
          handleClick={handleOnSignInNow}
        />
      </div> */}
    </div>
  );
}

export default ChoosePassword;
